import React from 'react';
import PropTypes from 'prop-types';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import ModalBody from './ModalBody';
import ModalPadding from './ModalPadding';
import Button from '../Buttons/Button';
import TextInput from '../Forms/TextInput';
import ErrorText from "../Forms/ErrorText";

const CreateNewModal = ({ children, contentType, onSubmitClick, onInputChange, inputPlaceholder, inputValue, inputMaxLength, nameExists, loading, inputRef, ...rest }) => (
  <div className="create-new-modal">
    <ModalHeader title={`Create a ${contentType}`} {...rest} />

    <form>
      <ModalBody>
        <ModalPadding>
          {children}

          <TextInput
            name={`${contentType}-name`}
            placeholder={inputPlaceholder}
            onChange={onInputChange}
            value={inputValue}
            maxLength={inputMaxLength}
            inputRef={inputRef}
          />
          {nameExists && <ErrorText>A folder with this title already exists</ErrorText>}
        </ModalPadding>
      </ModalBody>

      <ModalFooter>
        <Button type="submit" onClick={onSubmitClick} disabled={inputValue.length === 0 || nameExists} loading={loading}>Create</Button>
      </ModalFooter>
    </form>
  </div>
);

CreateNewModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  contentType: PropTypes.string,
  onSubmitClick: PropTypes.func,
  onInputChange: PropTypes.func,
  inputPlaceholder: PropTypes.string,
  inputValue: PropTypes.string,
  inputMaxLength: PropTypes.number,
  nameExists: PropTypes.bool,
  loading: PropTypes.bool,
  inputRef: PropTypes.func,
};

export default CreateNewModal;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/CreateNewModal.js